import { useState } from 'react'

import { copyToClipboard } from '~/utils/copyToClipboard'

export function useCopyValue(successMessage?: string) {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = (value: string, message?: string) => {
    if (!value) throw new Error('Value is required')
    copyToClipboard(value, message ?? (successMessage || 'Copied'))
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 1000)
  }

  return { isCopied, handleCopy }
}
